import React from "react";
import { Grid } from "@mui/material";
import { useSelector } from "react-redux";

const Project = () => {
    const myData = useSelector(state => state.user)
    console.log("Project", myData)
  
  return (
    <Grid container justifyContent="center">
      <Grid item sm={10}>
        <h1>Projects {myData.name}</h1>
        <hr />
        <p>Projects are mentioned below:</p>
      </Grid>
    </Grid>
  );
};

export default Project;
